import { Input, InputProps } from "reactstrap";
import { IsMobileAtom } from "../App";
import { useAtomValue } from "jotai";

function AppInput(props: InputProps) {
  const isMobile = useAtomValue(IsMobileAtom);

  return (
    <Input {...props} autoFocus={props?.autoFocus === true && !isMobile} />
  );
}

export default AppInput;
